<template>
  <span>
    {{ formatPaymentMethod(source, paymentMethod) }}
  </span>
</template>

<script>
export default {
  props: {
    source: {
      type: String,
      required: true,
    },
    paymentMethod: {
      type: Object || null || undefined,
      required: true,
    },
  },
  methods: {
    formatBrand(paymentMethod) {
      if (paymentMethod && paymentMethod.brand && paymentMethod.lastFour) {
        return `${paymentMethod.brand.toUpperCase()} •••• •••• •••• ${paymentMethod.lastFour}`
      }

      return ''
    },
    formatSource(source) {
      if (source === 'stripe') return ''

      const s = source.replace('_', ' ')

      return `${s[0].toUpperCase()}${s.slice(1)} `
    },
    formatPaymentMethod(source, paymentMethod) {
      return this.formatSource(source) + this.formatBrand(paymentMethod)
    },
  },
}
</script>
